import Vue from "vue";
import VueRouter from "vue-router";
const MealimWorkshop = () => import("@/views/MealimWorkshop.vue");

import Accueil from "@/views/Accueil.vue";
import NosEngagements from "@/views/NosEngagements.vue";
import MeilleursMangeurs from "@/views/MeilleursMangeurs.vue";
import Conseils from "@/views/Conseils.vue";
import AlimentationPositiveDurable from "@/views/AlimentationPositiveDurable.vue";
import NotreDemarche from "@/views/NotreDemarche.vue";
import ScoreMealim from "@/views/ScoreMealim.vue";
import ConseilScientifique from "@/views/ConseilScientifique.vue";
import QuiSommesNous from "@/views/QuiSommesNous.vue";
import Contact from "@/views/Contact.vue";
import PolitiqueDeConfidentialite from "@/views/PolitiqueDeConfidentialite.vue";
import Faq from "@/views/Faq.vue";
import PageIntrouvable from "@/views/PageIntrouvable.vue";
import MmmEnPratique from "@/views/MmmEnPratique.vue";
import LesMicroNutriments from "@/views/LesMicroNutriments.vue";
import Inscription from "@/views/Inscription.vue";
import Connection from "@/views/Connection.vue";
import Deconnection from "@/views/Deconnection.vue";
import FormulaireInscription from "@/views/FormulaireInscription.vue";
import MaFamille from "@/views/MaFamille.vue";
import MesPreferences from "@/views/MesPreferences.vue";
import MyAccount from "@/views/MyAccount.vue";

import MyMenusDay from "@/views/MyMenusDay.vue";
import NavbarLayout from "@/components/NavbarLayout.vue";

import ConsumerSpaceLayout from "@/components/ConsumerSpaceLayout.vue";
import MyMealView from "@/views/MyMealView.vue";
import MyShoppingList from "@/views/MyShoppingList.vue";
import DisableEmails from "@/views/DisableEmails.vue";
import DeleteAccount from "@/views/DeleteAccount.vue";
import MyMenusWeek from "@/views/MyMenusWeek.vue";
import MyBatchCooking from "@/views/MyBatchCooking.vue";
import MealIdeasView from "@/views/MealIdeasView.vue";
import MealIdeasShoppingList from "@/views/MealIdeasShoppingList.vue";

import RecipeView from "@/views/RecipeView.vue";
import RecipesListView from "@/views/RecipesListView.vue";
import PublicRecipeView from "@/views/PublicRecipeView.vue";
import BlogListView from "@/views/BlogListView.vue";
import BlogArticleView from "@/views/BlogArticleView.vue";
import Apports from "@/views/Apports.vue";
import AllMyLikedDishes from "@/views/AllMyLikedDishes.vue";
import ApportsIndividuels from "@/views/ApportsIndividuels.vue";
import ActualitesPat from "@/views/ActualitePat.vue";

import RecetteVinaigretteMaison from "@/views/RecetteVinaigretteMaison.vue";
import CouvertureBesoins from "@/views/CouvertureBesoins.vue";

Vue.use(VueRouter);

const routes = [
{
    path: "/",
    abstract: true,
    component: NavbarLayout,
    meta: { navigationContext: "public" },
    children: [
      { path: "/atelier-mealim", name: "mealim-workshop", component: MealimWorkshop },
      { path: "/atelier-mealim/recette", name: "mealim-recipe", component: MealimWorkshop },
      { path: "/atelier-mealim/rythme", name: "mealim-rhythm", component: MealimWorkshop },
      {
        path: "/",
        name: "accueil",
        component: Accueil
      },
      {
        path: "/meilleurs-mangeurs",
        name: "meilleurs-mangeurs",
        component: MeilleursMangeurs
      },
      {
        path: "/notre-demarche",
        name: "notre-demarche",
        component: NotreDemarche
      },
      {
        path: "/le-score-mealim",
        name: "public-score-mealim",
        redirect: "/atelier-mealim/recette"
      },
      {
        path: "/lalimentation-positive-et-durable",
        name: "lalimentation-positive-et-durable",
        component: AlimentationPositiveDurable
      },
      {
        path: "/nos-9-engagements",
        name: "nos-9-engagements",
        component: NosEngagements
      },
      {
        path: "/conseils",
        name: "conseils",
        component: Conseils
      },
      {
        path: "/conseils-scientifique",
        name: "conseils-scientifique",
        component: ConseilScientifique
      },
      {
        path: "/qui-sommes-nous-bak",
        name: "qui-sommes-nous",
        component: QuiSommesNous
      },
      {
        path: "/contact",
        name: "contact",
        component: Contact
      },
      {
        path: "/politique-de-confidentialite",
        name: "politique-de-confidentialite",
        component: PolitiqueDeConfidentialite
      },
      {
        path: "/faq",
        name: "faq",
        component: Faq
      },
      {
        path: "/se-desinscrire-des-emails",
        name: "disable-emails",
        component: DisableEmails
      },
      {
        path: "/supprimer-mon-compte",
        name: "delete-account",
        component: DeleteAccount
      },
      {
        path: "/mmm-en-pratique",
        name: "mmm-en-pratique",
        component: MmmEnPratique
      },
      {
        path: "/les-micro-nutriments",
        name: "les-micro-nutriments",
        component: LesMicroNutriments
      },
      {
        path: "/recettes",
        name: "recipes",
        component: RecipesListView
      },
      {
        path: "/recette",
        redirect: {
          name: "recipes"
        }
      },
      {
        path: "/recette/:id/:slug?",
        name: "recipe",
        component: PublicRecipeView
      },
      {
        path: "/actualites",
        name: "blog-list",
        component: BlogListView
      },
      {
        path: "/actualites/categorie/:categorySlug",
        name: "blog-category",
        component: BlogListView
      },
      {
        path: "/actualite/:articleSlug",
        name: "blog-article",
        component: BlogArticleView
      },
      // Redirects depuis les anciennes URLs
      {
        path: "/blog",
        redirect: { name: "blog-list" }
      },
      {
        path: "/blog/categorie/:categorySlug",
        redirect: to => ({ name: "blog-category", params: { categorySlug: to.params.categorySlug } })
      },
      {
        path: "/blog/article/:articleSlug",
        redirect: to => ({ name: "blog-article", params: { articleSlug: to.params.articleSlug } })
      },
      {
        path: "/recettes/:id",
        redirect: to => ({
          name: "recipe",
          params: {
            id: to.params.id
          },
          query: to.query
        })
      },
    ],
  },
  {
    path: "/inscription",
    name: "inscription",
    component: Inscription
  },
  {
    path: "/connection",
    name: "connection",
    component: Connection
  },

  {
    path: "/mon-espace",
    abstract: true,
    component: ConsumerSpaceLayout,
    meta: { navigationContext: "personal" },
    children: [
      // Déconnexion : on peut la laisser accessible (elle gère le cas)
      {
        path: "/deconnection",
        name: "deconnection",
        component: Deconnection
      },

      // Formulaire : selon ton flow, tu peux le protéger plus tard si nécessaire
      {
        path: "/formulaire-inscription",
        name: "formulaire-inscription",
        component: FormulaireInscription
      },

      { path: "/mon-batch-cooking", name: "my-batch-cooking", component: MyBatchCooking, meta: { requiresAuth: true } },
      // ✅ Routes protégées (espace utilisateur)
      {
        path: "/mes-menus",
        name: "my-menus",
        component: MyMenusWeek,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mes-idees-repas",
        name: "meal-ideas",
        component: MealIdeasView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mes-idees-repas/courses",
        name: "meal-ideas-shopping",
        component: MealIdeasShoppingList,
        meta: { requiresAuth: true }
      },
      {
        path: "/mon-menu",
        name: "my-menu",
        component: MyMenusDay,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mon-repas/:date/:meal",
        name: "my-meal",
        component: MyMealView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mes-courses",
        name: "my-shopping-list",
        component: MyShoppingList,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mes-preferences",
        name: "my-preferences",
        component: MesPreferences,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mes-plats-preferes",
        name: "my-liked-recipes",
        component: AllMyLikedDishes,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mon-compte",
        name: "my-account",
        component: MyAccount,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ma-famille",
        name: "ma-famille",
        component: MaFamille,
        meta: {
          requiresAuth: true
        }
      },

      // Recette interne (privée)
      {
        path: "recette/:id",
        name: "dish",
        component: RecipeView,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: "/mes-apports-nutritionnels",
        name: "apports",
        component: Apports,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/mes-apports-nutritionnels/:id",
        name: "apports_individuels",
        component: ApportsIndividuels,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/score-mealim",
        name: "score-mealim",
        component: ScoreMealim,
        meta: { requiresAuth: true }
      },
      {
        path: "/mode-demploi",
        redirect: { name: "notre-demarche" }
      },
      {
        path: "/actualites-pat",
        name: "actualites-pat",
        component: ActualitesPat,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/un-algorithme-de-personnalisation-alimentaire",
        redirect: { name: "notre-demarche" }
      },
      {
        path: "/mes-meilleurs-menus-au-quotidien",
        redirect: { name: "notre-demarche" }
      },
      {
        path: "/recette-de-vinaigrette-maison",
        name: "recette-de-vinaigrette-maison",
        component: RecetteVinaigretteMaison,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/couverture-des-besoins",
        name: "couverture-des-besoins",
        component: CouvertureBesoins,
        meta: {
          requiresAuth: true
        }
      },
    ],
  },

  {
    path: "/:catchAll(.*)",
    name: "PageIntrouvable",
    component: PageIntrouvable
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    // Ne pas remonter en haut si on reste sur la même route (changement de filtres/query)
    if (to.name && from.name && to.name === from.name) {
      return false;
    }
    return { x: 0, y: 0 };
  },
});

/**
 * ✅ Guard global :
 * - si une route nécessite auth et qu'il n'y a PAS de token -> redirection /connection
 * - évite les pages "loader infini" quand un lien est ouvert dans un navigateur intégré (PDF, Gmail, etc.)
 */
const hasAuthToken = () => {
  try {
    const access = localStorage.getItem("accessToken");
    const refresh = localStorage.getItem("refreshToken");
    return !!(access || refresh);
  } catch (e) {
    return false;
  }
};

const sharedNavigationPages = new Set(["recipes", "mealim-recipe", "mealim-workshop", "mealim-rhythm"]);
const isSharedNavigationPage = (route) => sharedNavigationPages.has(route.name);

router.beforeEach((to, from, next) => {
  if (isSharedNavigationPage(to) && to.name !== from.name) {
    try {
      const originIsShared = isSharedNavigationPage(from);
      const returnRoute = from.fullPath && from.fullPath.startsWith("/") && !from.fullPath.startsWith("//")
        ? from.fullPath
        : "/";
      window.sessionStorage.setItem("mmm-shared-page-return-route", returnRoute);
      if (!originIsShared) {
        const personalOrigin = from.matched.some((record) =>
          record.meta && record.meta.navigationContext === "personal"
        );
        window.sessionStorage.setItem("mmm-shared-page-context", personalOrigin ? "personal" : "public");
      }
    } catch (e) {
      // Fall back to the home page when session storage is unavailable.
    }
  }

  if (to.name === "recipes" && from.name && from.name !== "recipes" && from.name !== "recipe") {
    try {
      window.sessionStorage.setItem("mmm-recipes-return-route", from.fullPath || "/");
    } catch (e) {
      // The catalogue falls back to the home page when session storage is unavailable.
    }
  }

  const requiresAuth = to.matched.some((r) => r.meta && r.meta.requiresAuth);
  if (!requiresAuth) return next();

  if (!hasAuthToken()) {
    return next({
      name: "connection",
      query: {
        redirect: to.fullPath
      },
    });
  }

  return next();
});

export default router;

